import React from 'react';
import Icon from './Icon';
import Reveal from './Reveal';
import './Vision.css';

export default function Vision() {
  return (
    <section className="vision section" id="vision">
      <div className="container vision__inner">
        <Reveal className="vision__card vision__card--teal">
          <span className="vision__icon">
            <Icon name="target" size={24} />
          </span>
          <span className="eyebrow eyebrow--light">Our Purpose &amp; Aim</span>
          <h3>Why BikesDrop exists</h3>
          <p>
            To close the gap between people who need something moved and the riders and businesses
            ready to move it, using technology to make logistics in Ghana faster, fairer and more
            reliable for everyone involved, one delivery at a time.
          </p>
        </Reveal>

        <Reveal delay={100} className="vision__card vision__card--dark">
          <span className="vision__icon">
            <Icon name="rocket" size={24} />
          </span>
          <span className="eyebrow eyebrow--light">Our Vision</span>
          <h3>Ghana&rsquo;s leading logistics super-app</h3>
          <p>
            To become the platform Ghana, and eventually West Africa, trusts by default for delivery,
            cargo and everyday errands, while creating dependable income for thousands of riders and
            digital reach for thousands of merchants and market women.
          </p>
        </Reveal>

        <Reveal delay={200} className="vision__card vision__card--amber">
          <span className="vision__icon">
            <Icon name="users" size={24} />
          </span>
          <span className="eyebrow eyebrow--light">Our Mission</span>
          <h3>Connect. Deliver. Empower.</h3>
          <p>
            To connect customers, riders and merchants through fast, transparent and fair technology,
            empowering informal traders and independent riders to grow alongside a platform built for
            them, not around them.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
